import React from "react";
import QuoteInfo from "../../../ShipmentQuotes/components/QuoteInfo";
import QuickQuoteInfo from "../../../ShipmentQuotes/components/QuickQuoteInfo";

interface HeaderProps {
  isQuickRequest: boolean;
  data: any;
  loadingData: boolean;
  fetchData: any;
  setIsConsolidated: any;
}

function Header({ isQuickRequest, data, loadingData, fetchData, setIsConsolidated }: HeaderProps) {
  return (
    <div>
      {isQuickRequest ? (
        <QuickQuoteInfo data={data} loadingData={loadingData} />
      ) : (
        <QuoteInfo fetchData={fetchData} data={data} loadingData={loadingData} setIsConsolidated={setIsConsolidated} />
      )}
    </div>
  );
}

export default Header;
